var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-1ad32651-d0ab-4896-befa-939dc3a28d41",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.18,
    height: 7.8,
    viewBox: "0 0 13.18 7.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-65efa77d-c9a2-4098-807c-fd8464ef1dcd",
    "data-name": "Object"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.48.41H.2c-.11,0-.2-.09-.2-.2s.09-.2.2-.2h9.28c.11,0,.2.09.2.2s-.09.2-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48,4.11H.2c-.11,0-.2-.09-.2-.2s.09-.2.2-.2h9.28c.11,0,.2.09.2.2s-.09.2-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48,7.8H.2c-.11,0-.2-.09-.2-.2s.09-.2.2-.2h9.28c.11,0,.2.09.2.2s-.09.2-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.98,4.11h-1.54c-.11,0-.2-.09-.2-.2s.09-.2.2-.2h1.54c.11,0,.2.09.2.2s-.09.2-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.98.43h-1.54c-.11,0-.2-.09-.2-.2s.09-.2.2-.2h1.54c.11,0,.2.09.2.2s-.09.2-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.98,7.8h-1.54c-.11,0-.2-.09-.2-.2s.09-.2.2-.2h1.54c.11,0,.2.09.2.2s-.09.2-.2.2Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleList);
export default __webpack_public_path__ + "static/media/icon_module_list.9cfb2360a37278f434096dae718fb8c5.svg";
export { ForwardRef as ReactComponent };